import React, { FC, useState } from 'react';
import { Box, Button, HStack } from '@chakra-ui/react';
import { Allocate } from '@app/components/Dividends/components/Allocate';
import { Deallocate } from '@app/components/Dividends/components/Deallocate';

type View = 'allocate' | 'deallocate';

interface Props {
  onClose: () => void;
}

export const Dividends: FC<Props> = ({ onClose }) => {
  const [view, setView] = useState<View>('allocate');

  function renderViewButton(label: string, _view: View) {
    const isActive = _view === view;

    return (
      <Button
        variant="tertiary"
        onClick={() => setView(_view)}
        sx={{
          color: isActive ? 'orange' : 'gray.4',
          bg: isActive ? 'gray.2' : 'transparent',
          textTransform: 'capitalize'
        }}
      >
        {label}
      </Button>
    );
  }

  return (
    <Box
      sx={{
        padding: '24px',
        background: 'black',
        border: '1px solid',
        borderColor: 'gray.5',
        borderRadius: '16px'
      }}
    >
      <HStack
        width="100%"
        sx={{
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'gray.5',
          padding: '8px 10px'
        }}
      >
        {renderViewButton('Allocate', 'allocate')}
        {renderViewButton('Deallocate', 'deallocate')}
      </HStack>
      {view === 'allocate' && <Allocate />}
      {view === 'deallocate' && <Deallocate onClose={onClose} />}
    </Box>
  );
};
